const namespace = '[ENTITY_SITES]';

export const FETCH_SITES = `${namespace} FETCH_SITES`;
export const SET_SITES = `${namespace} SET_SITES`;
